module.exports = __webpack_public_path__ + "img/interpackmaxi.5e25d282.png";